module.exports = __webpack_public_path__ + "img/delete-icon.326fcdd0.svg";